export enum ADDRESS_STATUS {
  VERIFIED = "VERIFIED",
  UNVERIFIED = "UNVERIFIED",
}

export enum DOCUMENT_VERIFICATION_STATUS {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum GEOFENCE_STATUS {
  INSIDE = "INSIDE",
  OUTSIDE = "OUTSIDE",
}

export enum API_RESPONSE_STATUS {
  IDLE = "idle",
  LOADING = "loading",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}

export enum TIMER_CONST {
  globalTimeForRefresh = 60,
  pullTimeForRefresh = 64,
}

export enum UnitOfMeasure {
  PIECES = "Pieces",
  GRAMS = "Grams",
}

export enum QcVerificationStatus {
  VERIFIED = "VERIFIED",
  VERIFIED_ISSUES = "VERIFIED_ISSUES",
  PARTIALLY_VERIFIED = "PARTIALLY_VERIFIED",
  PARTIALLY_VERIFIED_ISSUES = "PARTIALLY_VERIFIED_ISSUES",
  UNVERIFIED = "UNVERIFIED",
  ALL = "ALL",
}

export const COUNTRY_URL_KEYS = {
  EWINGS: "ewings",
  EWINGS_DRIVER: "ewings-driver",
  WINGS: "wings",
  DELVE: "delve",
  FF_UM:"ff-user-management"
} as const;

export const ConfigType = [
  "ROUTE",
  "DRIVER_TRIP",
  "PICKED_UP",
  "USER_FEATURE",
  "CLUBBING",
  "ON_DEMAND_RIDER",
  "TRACKING"
];

export const consignmentStatus = {
  UNASSIGNED: {
    color: "INFO_BLUE",
  },
  ON_HOLD: {
    color: "MINSK",
  },
  ASSIGNED: {
    color: "MINSK",
  },
  READY_TO_DISPATCH: {
    color: "READY_BLUE",
  },
  OUT_FOR_DELIVERY: {
    color: "PRIMARY_BLUE",
  },
  DELIVERED: {
    color: "JUNGLE_GREEN",
  },
  PARTIALLY_DELIVERED: {
    color: "PARTIAL_SUCCESS_GREEN",
  },
  DELIVERY_ATTEMPTED: {
    color: "ALERT_ORANGE",
  },
  CANCELLED_BY_SOURCE: {
    color: "PALE_GRAY",
  },
  DELIVERY_FAILED: {
    color: "ERROR_RED",
  },
  PACKING_COMPLETE: {
    color: "MINSK",
  },
}

export const COUNTRY_URL = "fulfilment/v2/country/url"

export const VEHICLE_LABEL_MAP: Record<string, string> = {
  BIKE: "Bike",
  BICYCLE: "Bicycle",
  CAR: "Car",
};
